/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GetActionsDto } from '../models/get-actions-dto';
import { GetAllInvoicesFilters } from '../models/get-all-invoices-filters';
import { InvoiceDto } from '../models/invoice-dto';
import { InvoiceGetAllReportResp } from '../models/invoice-get-all-report-resp';
import { InvoiceGetAllResp } from '../models/invoice-get-all-resp';
import { InvoiceGetResp } from '../models/invoice-get-resp';
import { InvoiceProductResp } from '../models/invoice-product-resp';
import { InvoiceProducts } from '../models/invoice-products';
import { MarkAsPaidReq } from '../models/mark-as-paid-req';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation invoiceGet
   */
  static readonly InvoiceGetPath = '/invoice/{uuid}';

  /**
   * Get a invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invoiceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  invoiceGet$Response(params: {

    /**
     * invoice uuid
     */
    uuid: string;

    /**
     * Decide if generate PDF
     */
    generate_pdf?: boolean;

    /**
     * Invoice password
     */
    password?: string;
  }): Observable<StrictHttpResponse<InvoiceGetResp>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.InvoiceGetPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
      rb.query('generate_pdf', params.generate_pdf, {});
      rb.query('password', params.password, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceGetResp>;
      })
    );
  }

  /**
   * Get a invoice
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `invoiceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invoiceGet(params: {

    /**
     * invoice uuid
     */
    uuid: string;

    /**
     * Decide if generate PDF
     */
    generate_pdf?: boolean;

    /**
     * Invoice password
     */
    password?: string;
  }): Observable<InvoiceGetResp> {

    return this.invoiceGet$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceGetResp>) => r.body as InvoiceGetResp)
    );
  }

  /**
   * Path part for operation delete
   */
  static readonly DeletePath = '/invoice/{uuid}';

  /**
   * Delete the desired invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `delete()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete$Response(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<InvoiceGetResp>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.DeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceGetResp>;
      })
    );
  }

  /**
   * Delete the desired invoice
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `delete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete(params: {

    /**
     * product uuid
     */
    uuid: string;
  }): Observable<InvoiceGetResp> {

    return this.delete$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceGetResp>) => r.body as InvoiceGetResp)
    );
  }

  /**
   * Path part for operation invoicePut
   */
  static readonly InvoicePutPath = '/invoice';

  /**
   * Put an invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invoicePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invoicePut$Response(params: {
    body: InvoiceDto
  }): Observable<StrictHttpResponse<InvoiceGetResp>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.InvoicePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceGetResp>;
      })
    );
  }

  /**
   * Put an invoice
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `invoicePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invoicePut(params: {
    body: InvoiceDto
  }): Observable<InvoiceGetResp> {

    return this.invoicePut$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceGetResp>) => r.body as InvoiceGetResp)
    );
  }

  /**
   * Path part for operation invoiceMarkAsPaid
   */
  static readonly InvoiceMarkAsPaidPath = '/invoice/markAsPaid';

  /**
   * Mark as paid an invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invoiceMarkAsPaid()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invoiceMarkAsPaid$Response(params: {
    body: MarkAsPaidReq
  }): Observable<StrictHttpResponse<GetActionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.InvoiceMarkAsPaidPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetActionsDto>;
      })
    );
  }

  /**
   * Mark as paid an invoice
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `invoiceMarkAsPaid$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invoiceMarkAsPaid(params: {
    body: MarkAsPaidReq
  }): Observable<GetActionsDto> {

    return this.invoiceMarkAsPaid$Response(params).pipe(
      map((r: StrictHttpResponse<GetActionsDto>) => r.body as GetActionsDto)
    );
  }

  /**
   * Path part for operation getAllInvoices
   */
  static readonly GetAllInvoicesPath = '/invoice/getAllReport';

  /**
   * A report of al invoices
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllInvoices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllInvoices$Response(params: {
    body: GetAllInvoicesFilters
  }): Observable<StrictHttpResponse<InvoiceGetAllReportResp>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.GetAllInvoicesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceGetAllReportResp>;
      })
    );
  }

  /**
   * A report of al invoices
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllInvoices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllInvoices(params: {
    body: GetAllInvoicesFilters
  }): Observable<InvoiceGetAllReportResp> {

    return this.getAllInvoices$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceGetAllReportResp>) => r.body as InvoiceGetAllReportResp)
    );
  }

  /**
   * Path part for operation getAll
   */
  static readonly GetAllPath = '/invoice/getAll';

  /**
   * All invoices acording to some filters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAll$Response(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: GetAllInvoicesFilters
  }): Observable<StrictHttpResponse<InvoiceGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.GetAllPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceGetAllResp>;
      })
    );
  }

  /**
   * All invoices acording to some filters
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAll(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: GetAllInvoicesFilters
  }): Observable<InvoiceGetAllResp> {

    return this.getAll$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceGetAllResp>) => r.body as InvoiceGetAllResp)
    );
  }

  /**
   * Path part for operation getClientData
   */
  static readonly GetClientDataPath = '/invoice/getClientData/{uuid}';

  /**
   * Get Client Data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientData$Response(params: {

    /**
     * Client uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<InvoiceGetResp>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.GetClientDataPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceGetResp>;
      })
    );
  }

  /**
   * Get Client Data
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClientData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientData(params: {

    /**
     * Client uuid
     */
    uuid: string;
  }): Observable<InvoiceGetResp> {

    return this.getClientData$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceGetResp>) => r.body as InvoiceGetResp)
    );
  }

  /**
   * Path part for operation getProductsFromInvoice
   */
  static readonly GetProductsFromInvoicePath = '/invoice/products';

  /**
   * Get product report from filters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductsFromInvoice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductsFromInvoice$Response(params: {
    body: InvoiceProducts
  }): Observable<StrictHttpResponse<InvoiceProductResp>> {

    const rb = new RequestBuilder(this.rootUrl, InvoiceService.GetProductsFromInvoicePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceProductResp>;
      })
    );
  }

  /**
   * Get product report from filters
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductsFromInvoice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductsFromInvoice(params: {
    body: InvoiceProducts
  }): Observable<InvoiceProductResp> {

    return this.getProductsFromInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceProductResp>) => r.body as InvoiceProductResp)
    );
  }

}
